module.exports = __webpack_public_path__ + "img/claim2.92de9d97.png";